export const ConnectionStatusCodes = {
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    TIMEOUT: 'TIMEOUT',
    ERROR: 'ERROR',
    DISCONNECTED: 'DISCONNECTED',
    DEACTIVATED: 'DEACTIVATED',
    NOT_CONFIGURED: 'NOT_CONFIGURED',
    TESTING_CONNECTION: 'TESTING_CONNECTION',
    LAST_CONNECTION_SUCCESS: 'LAST_CONNECTION_SUCCESS',
    LAST_CONNECTION_FAILED: 'LAST_CONNECTION_FAILED',
} as const;

export type ConnectionStatus = (typeof ConnectionStatusCodes)[keyof typeof ConnectionStatusCodes];

export const TestConnectionStatus = {
    IDLE: 'IDLE',
    TESTING: 'TESTING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
} as const;

export type TestConnectionState =
    | {
          status:
              | typeof TestConnectionStatus.IDLE
              | typeof TestConnectionStatus.SUCCESS
              | typeof TestConnectionStatus.TESTING;
      }
    | { status: typeof TestConnectionStatus.ERROR; message: string };

export type IdentityProviderMappingAPI = {
    identityProviderField: string;
    operatorField: string;
};

export type CreateOrUpdateActiveDirectoryApiRequest = {
    name: string;
    url: string;
    group: string;
    interval: string;
    username: string;
    userGroup: string;
    password?: string;
    mappings: IdentityProviderMappingAPI[];
    identityProviderAttributes: string[];
};

export const ActiveDirectoryDetailsSteps = {
    CONNECTION: 'CONNECTION',
    DATA_POINTS: 'DATA_POINTS',
} as const;

export type ActiveDirectoryDetailsStep = (typeof ActiveDirectoryDetailsSteps)[keyof typeof ActiveDirectoryDetailsSteps];

export type ActiveDirectoryDetailsFormState = {
    name: string;
    url: string;
    group: string;
    interval: string;
    username: string;
    userGroup: string;
    password: string;
    mappings: { index: number; identityProviderField: string; operatorField: string }[];
};

export type IdentityProviderMapping = {
    index: number;
    identityProviderField: string;
    operatorField: string;
};

export type LdapCheckJobDetail = {
    success: boolean;
    identityProviderAttributes: string[];
    errorReason?: string;
};

export type ActiveDirectoryListItemAPI = {
    id: string;
    name: string;
    status: string;
    lastSync: string | null;
    existDataMapping: boolean;
    hasSavedPassword: boolean;
    active: boolean;
    errorConnectionDetail?: string;
    lastAttempt?: string;
};

export type ActiveDirectoryMappingsAPI = {
    identityProviderField: string;
    operatorField: string;
};

export type ActiveDirectoryDetailsItemAPI = {
    id: string;
    name: string;
    url: string;
    group: string;
    interval: string;
    username: string;
    userGroup: string;
    status: string;
    lastSync: string | null;
    existDataMapping: boolean;
    hasSavedPassword: boolean;
    active: boolean;
    errorConnectionDetail?: string;
    lastAttempt?: string;
    mappings: ActiveDirectoryMappingsAPI[];
    identityProviderAttributes: string[];
};

export type CheckActiveDirectoryConnectionPayload = {
    connectionId?: string;
    name: string;
    url: string;
    group: string;
    username: string;
    userGroup: string;
    password: string;
};
